import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'

const Row = styled.div`
  display: grid;

  grid-template-columns: ${rem(120)} 1fr;

  ${mediaQueryUp.tablet} {
    grid-template-columns: ${rem(150)} 1fr;
  }

  gap: ${rem(12)};
`

interface Props {
  label: string
  content: string
}

function AgentHubSetupPaymentDetailsVerificationRow(props: Props) {
  const { label, content } = props
  const intl = useIntl()

  return <Row>
    <BodyTextBlock variant="medium" weight="bold" colour="neutral-two">
      {intl.formatMessage({
        id: 'bsbl4Yc5FZtyJE3oaBoQ',
        defaultMessage: '{label}:',
        description: 'Payment details verification row label with colon separator',
      }, { label })}
    </BodyTextBlock>
    <BodyTextBlock variant="medium" colour="neutral-two">
      {content}
    </BodyTextBlock>
  </Row>
}

export default AgentHubSetupPaymentDetailsVerificationRow
